// extracted by mini-css-extract-plugin
module.exports = {"rotation":"SostenibilitaHubTemplate_rotation__oQjwU"};